import React from 'react';
import { string, shape, func } from 'prop-types';

import IconShippingTruck from '../../../icons/sources/shipping-truck';
import IconEshop from '../../../icons/sources/eshop';

const namespace = 'ui-search-fullsnackbar';

/**
 * IconSection component
 *
 * @component
 * @param {Object} props
 * @param {string} props.assetUrl - URL of the e-shop icon image
 * @param {Object} props.title - Title configuration
 * @param {string} props.title.first_text - First part of the title text
 * @param {string} props.title.last_text - Last part of the title text
 * @param {string} props.title.asset_image - Asset image for the title
 * @param {Object} props.progressBar - Progress bar configuration
 * @param {string} props.progressBar.color_hex - Hex color code for the shipping truck container background
 * @param {Function} props.wrapIcon - Function to wrap the e-shop icon with additional styling or behavior
 * @returns {React.ReactElement} The icon section component
 */
const IconSection = ({ assetUrl, title, progressBar, wrapIcon }) => (
  <div className={`${namespace}__icon-container`}>
    {assetUrl ? (
      <div className={`${namespace}__eshop-container`}>{wrapIcon(<IconEshop image={assetUrl} />)}</div>
    ) : (
      title && (
        <div className={`${namespace}__shippingtruck-container`} style={{ backgroundColor: progressBar?.color_hex }}>
          <IconShippingTruck />
        </div>
      )
    )}
  </div>
);

IconSection.propTypes = {
  assetUrl: string,
  progressBar: shape({
    color_hex: string,
  }),
  title: shape({
    first_text: string,
    last_text: string,
    asset_image: string,
  }),
  wrapIcon: func,
};

export default IconSection;
